
<template>
  <div class="about-area ptb-100">
    <div class="container">
      <div class="row">
        <div class="col-lg-6 col-md-12">
          <div class="about-image bg1">
            <img src="../../assets/images/about/about1.jpg" alt="Fontes Business - Desenvolvimento de Software">
          </div>
        </div>
        <div class="col-lg-6 col-md-12">
          <div class="about-content" data-aos="fade-up" data-aos-duration="1200">
            <span class="sub-title">Sobre Nós</span>
            <h2>A história por trás da Fontes Business</h2>
            <p>Fundada em maio de 2018 no Rio de Janeiro, a Fontes Business nasceu com o propósito de transformar ideias em soluções digitais inovadoras. Hoje, sediada em Canela-RS, combinamos expertise técnica com visão estratégica para impulsionar o crescimento dos nossos clientes.</p>
            <ul class="about-list">
              <li>
                <div class="icon">
                  <i class="ph-checks"></i>
                </div>
                Inovação Integrada
                <router-link to="/services-details" class="link-btn">
                  <i class="ph-caret-right"></i>
                </router-link>
              </li>
              <li>
                <div class="icon">
                  <i class="ph-checks"></i>
                </div>
                Cultura Colaborativa
                <router-link to="/services-details" class="link-btn">
                  <i class="ph-caret-right"></i>
                </router-link>
              </li>
              <li>
                <div class="icon">
                  <i class="ph-checks"></i>
                </div>
                Planejamento Estratégico
                <router-link to="/services-details" class="link-btn">
                  <i class="ph-caret-right"></i>
                </router-link>
              </li>
              <li>
                <div class="icon">
                  <i class="ph-checks"></i>
                </div>
                Equipe Profissional
                <router-link to="/services-details" class="link-btn">
                  <i class="ph-caret-right"></i>
                </router-link>
              </li>
            </ul>
            <router-link to="/about-us" class="btn-style-one red-light-color">
              Saiba Mais Sobre Nós
              <i class="ph-caret-right"></i>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'About'
}
</script>